import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import useFileManagerApi from "./api/useFileManagerApi";

const useSelectedFolders = () => {
  const { fetchFolderStructure } = useFileManagerApi();
  const [folderStructure, setFolderStructure] = useState({});
  const [selectedFolders, setSelectedFolders] = useState([]);

  const loadFolderStructure = useCallback(async () => {
    try {
      const sanitizedStructure = await fetchFolderStructure();
      setFolderStructure(sanitizedStructure);
      return sanitizedStructure;
    } catch (error) {
      toast.error("Error fetching data");
      throw error;
    }
  }, [fetchFolderStructure]);

  useEffect(() => {
    loadFolderStructure().catch(() => {});
  }, [loadFolderStructure]);

  const handleCheckboxChange = useCallback((item, isChecked) => {
    if (!item) {
      return;
    }

    const normalizedItem =
      typeof item === "string"
        ? { id: item, name: item, type: "file", path: item }
        : {
            ...item,
            id:
              item.id ||
              item.name ||
              item.path ||
              item.fullPath ||
              `selection-${Date.now()}-${Math.random()}`,
            name: item.name || item.id || "",
            type: item.type || item.itemType || (item.isFolder ? "folder" : "file"),
            path: item.path || item.fullPath || item.id || item.name || "",
          };

    setSelectedFolders((prev) => {
      if (!Array.isArray(prev)) {
        return isChecked ? [normalizedItem] : [];
      }

      if (isChecked) {
        if (prev.some((selected) => selected.id === normalizedItem.id)) {
          return prev;
        }
        return [...prev, normalizedItem];
      }

      return prev.filter((selected) => selected.id !== normalizedItem.id);
    });
  }, []);

  const updateFolderStructure = useCallback((newStructure) => {
    setFolderStructure(newStructure);
  }, []);

  const clearSelectedFolders = useCallback(() => {
    setSelectedFolders([]);
  }, []);

  const refreshFolderStructure = useCallback(async () => {
    return loadFolderStructure();
  }, [loadFolderStructure]);

  return {
    folderStructure,
    selectedFolders,
    handleCheckboxChange,
    updateFolderStructure,
    refreshFolderStructure,
    clearSelectedFolders,
  };
};

export default useSelectedFolders;

